import { Update } from '@ngrx/entity'
import { createAction, props } from '@ngrx/store'
import { ProfileEntity } from 'libs/gb-front/selected-profile/data-access/src/lib/+state/selected-profile.models'

export const initPublicChannel = createAction('[Auction/Page] Initialise Gb Realtime Public Channel')

export const initPrivateVolunteerChannel = createAction('[Auction/Page] Initialise Private Volunteer Realtime Channel')

export const initPrivateAuctionProfileChannel = createAction(
  '[Auction/Page] Initialise Private Auction Profile Channel',
)

export const updateAuctionProfileRealtime = createAction(
  '[Authentication] Update AuthProfile Realtime',
  props<{ update: Update<ProfileEntity> }>(),
)

export const unsubscribePrivateChannel = createAction('[Auction/Page] unsubscribe Private Channel')
